import React from 'react';
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import GridBg from "../../gridBg/gridBg"
import './styles.scss'

const MobileAdviser = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allDataYaml {
            edges {
              node {
                mobilelp {
                  adviser {
                    members {
                      key
                      name
                      belonging
                      description
                      comment
                    }
                    title
                  }
                }
                language
              }
            }
          }
          memberPhotoFile: allFile(filter: {relativePath: {glob: "mobilelp/adviser/members/*"}}, sort: {fields: name}) {
            nodes {
              name
              childImageSharp {
                fluid(maxWidth: 184, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          companyLogoFile: allFile(filter: {relativePath: {glob: "mobilelp/adviser/company-logos/*"}}, sort: {fields: name}) {
            nodes {
              name
              childImageSharp {
                fluid(maxWidth: 552) {
                  src
                }
              }
            }
          }
        }
      `}
      render={({ allDataYaml: { edges }, memberPhotoFile, companyLogoFile }) => {
        const { node: { mobilelp: { adviser } } } = edges.find(({node}) => node.language === props.language)

        // only pick first adviser for now
        const member = adviser.members[0]
        const memberPhoto = memberPhotoFile.nodes.find(({name}) => name === member.key)

        return <div className="mobile-adviser w-100">
          <h2 className="mobile-adviser-heading text-center px-5">{adviser.title}</h2>
          <div className="mobile-adviser-member px-4">
            <div className="container-fluid">
              <div className="adviser-row row align-items-center justify-content-center bg-white px-1 py-3 px-md-3 py-md-4 py-xl-5">
                <div className="col-8 col-md-4 col-lg-3 col-xl-2 p-4 p-md-3 p-xl-0">
                  <div className="adviser-member-icon mx-auto">
                    <Img
                      alt={member.name}
                      fluid={memberPhoto.childImageSharp.fluid}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
                <div className="col-12 col-md-8 col-lg-9 col-xl-3 text-center text-md-left pl-xl-1">
                  <h5>{member.name}</h5>
                  <div className="adviser-member-belonging mt-4 mt-sm-3">({member.belonging})</div>
                  <p className="adviser-member-description mt-3">{member.description}</p>
                </div>
                <div className="col-12 col-md-12 col-xl-7 p-3 rounded">
                  <div className="adviser-member-comment p-4 p-md-5" dangerouslySetInnerHTML={{__html: member.comment}} />
                </div>
              </div>
            </div>
            <div className="customer-logo-container mx-auto">
              <div className="container-fluid mt-3 mt-md-5 pb-5 pb-md-0">
                <div className="row">
                  {
                    companyLogoFile.nodes.map(logo => {
                      return <div className="col-6 col-md-4 col-xl-4 p-3 px-sm-4 py-sm-3" key={logo.name}>
                        <img
                          alt={logo.name}
                          src={logo.childImageSharp.fluid.src}
                          loading="lazy"
                          decoding="async"
                        />
                      </div>
                    })
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="skew-section-line d-none d-md-block">
            <GridBg color="gray" topBgColor="gray" bottomBgColor="white" />
          </div>
        </div>
      }}
    />
  )
}

export default MobileAdviser
